<script setup>
import LayoutMainContent from "@/layout/components/LayoutMainContent.vue";
import LayoutRightPanel from "@/layout/components/LayoutRightPanel.vue";
</script>
<template>
  <div class="flex-1 relative flex items-start">
    <main class="flex-1 min-w-0">
      <LayoutMainContent />
    </main>

    <LayoutRightPanel />
  </div>
</template>

<style lang="scss" scoped></style>
